module.exports = __webpack_public_path__ + "static/media/emma_01.5f3be774.png";